import { render } from "./TranscriptionUploadAlert.vue?vue&type=template&id=6991c871&scoped=true"
import script from "./TranscriptionUploadAlert.vue?vue&type=script&lang=js"
export * from "./TranscriptionUploadAlert.vue?vue&type=script&lang=js"

import "./TranscriptionUploadAlert.vue?vue&type=style&index=0&id=6991c871&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6991c871"

export default script